exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main[data-v-dbc7fe20] {\n  width: 100%;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n\n", ""]);

// exports
